import { Observable } from 'rxjs';
import { TranslationModel } from '../models/translation.model';
import { LanguageModel } from '../models/language.model';

export abstract class TranslationsRepository {
    abstract load(lang: string): Observable<TranslationModel>;
    abstract getLanguague(): Observable<LanguageModel>;
}
